<template>
    <div class="mm-timeline"
        :class="timelineClassname">
        <div class="mm-timeline__mobile-move-right">
            <div class="mm-timeline__axe box--space-top">
            </div>

            <div class="mm-timeline__row"
                v-for="(item, index) in items"
                :key="item.id">

                <div class="mm-timeline-layout">
                    <div class="mm-timeline-layout__content ">
                        <div class="container-fluid mm-timeline__content">
                            <div class="mm-timeline__circle box--space-top">
                                <div class="mm-timeline__circle__inner"></div>
                                <div v-if="index === items.length - 1"
                                    class="mm-timeline__hide-line-bottom">
                                </div>
                            </div>

                            <div class="row"
                                :class="dynamicClass(index)">
                                <div class="col-md">
                                    <div class="box box--space-top"
                                        :class="{
                                            'content-md-right': index%2 !== 0
                                        }">
                                        <span class="headline headline--fourth">
                                            {{item.title}}
                                        </span>
                                        <span class="headline headline--sixth">
                                            {{item.description}}
                                        </span>
                                    </div>
                                </div>
                                <div class="col-1">
                                </div>
                                <div class="col-md">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <img v-if="item.responsiveImage"
                    :src="item.responsiveImage.src"
                    :srcset="item.responsiveImage.srcset"
                    :class="{
                        'mm-timeline__image--right': index%2 !== 0
                    }"
                    :style="dynamicImageStyle(index)"
                    class="mm-timeline__image"
                />

                <div class="mm-timeline__mask"
                    :class="{'mm-timeline__mask--right': index%2 !== 0}">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
            required: true
        },
        timelineClassname: {
            type: String
        }
    },
    methods: {
        dynamicImageStyle() {
            let rightStyle = {};

            return {
                top: '0',
                ...rightStyle
            };
        },
        dynamicClass(index) {
            if (index%2 === 0) {
                return 'row d-flex flex-row-reverse';
            }
            return 'row';
        }
    }
}
</script>